module.exports = __webpack_public_path__ + "img/PR1-F.ac617a39.png";